import script from "./ServiceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceDetail.vue?vue&type=script&setup=true&lang=js"

import "./ServiceDetail.vue?vue&type=style&index=0&id=04857b60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04857b60"]])

export default __exports__